import { StructuredText } from "datocms-structured-text-utils"
import React from "react"

import Header from "../../../../design-system/header"
import PaperExpandable from "../../../../design-system/paper-expandable"
import { StructuredTextBase } from "../../../../shared-components/cms-article-content/structured-text-base"
import Block, { BlockProps as AccordionContent } from "./block"
import * as styles from "./index.module.scss"

export type Props = {
  id: string
  title: string
  content: StructuredText
}

const BlogAccordion = ({ title, id, content }: Props) => (
  <figure className={styles.figure}>
    <PaperExpandable
      className={styles.accordion}
      chevronSmall
      paddingSmall
      id={id}
      trigger={
        <Header variant="4" as="h4">
          {title}
        </Header>
      }
    >
      <div className={styles.accordionContent}>
        <StructuredTextBase
          body={content}
          renderBlock={({ record }) => (
            <Block {...(record as AccordionContent)} />
          )}
        />
      </div>
    </PaperExpandable>
  </figure>
)

export default BlogAccordion
